import React from 'react';

import { t } from '../../services/i18nService';
import styles from './options.scss';
import childTestStyles from '../testOverview/testOverview.scss';

import OptionsTopBar from './OptionsTopBar';
import QTIAssessmentItem from '../question/QTIAssessmentItem';
import sessionReader from '../../store/readHelpers/SessionReader';
import questionHelperServices from '../../services/questionView/QuestionHelperServices';
import parentTestService from '../../services/ParentTestService';

const OptionsTestInstructions = () => {
    const childTest = parentTestService.getChild(sessionReader.getAssessmentRunId());
    const question = childTest?.documentModel || {};
    const emptyFunction = () => {};

    return (
        <div>
            <OptionsTopBar title={t('options.testInstructions')} showOptionsButton />

            <div className={styles.mainContentArea} role="main">
                <div className={childTestStyles.actionBox}>
                    <div className={childTestStyles.descriptionDocumentBody}>
                        <QTIAssessmentItem
                            callback={emptyFunction}
                            userResponses={{}}
                            context={sessionReader.getContext()}
                            reportReady={emptyFunction}
                            question={question}
                            lockedMedia
                            services={questionHelperServices.getServices()}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OptionsTestInstructions;
